import { Formik } from "formik";
import { useState } from "react";
import Eye from "../../components/forms/Eye";
import Loader from "../../components/loader";
import { useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../../layout/AuthLayout";
import { signInSchema } from "../../utils/schema";
import { webPaths } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { authLogin } from "../../redux/actions/authAction";
import ErrorMessage from "../../components/forms/ErrorMessage";
import useCountry from "../../components/hooks/useCountry";
import { buildAuthModalState } from "../../routes/authModal";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const countryData = useCountry();
  const [isEye, setIsEye] = useState(false);
  const { isLoading } = useSelector((state) => state.authReducer);

  const initialValues = {
    identifier: "",
    password: "",
  };

  const handleLogin = async (values) => {
    const callback = (response) => {
      if (response.success) navigate(webPaths?.Home);
    };
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.identifier);

    const payload = {
      password: values.password,
      country: countryData?.country_name || "India",
      ...(isEmail
        ? { email: values.identifier }
        : { phone_no: `${countryData?.country_calling_code}${values.identifier}` }),
    };

    dispatch(
      authLogin({
        payload,
        callback,
      }),
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <AuthLayout>
      <div class="col-lg-12 mx-auto  login-popup__left ct_custom_scroll">
        <Formik
          initialValues={initialValues}
          validationSchema={signInSchema}
          onSubmit={(values, actions) => {
            handleLogin(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div>
                <div class="login-popup__brand mb-3">
                  <img
                    onClick={() => {
                      navigate(webPaths?.WebHome);
                    }}
                    style={{ cursor: "pointer" }}
                    src="/assets/img/logo_black.png"
                    class="main-logo"
                    alt="SecurPoint"
                  />
                </div>

                <h5 class="login-popup__title mb-2 ct_fs_28 text-center">
                  Welcome!
                </h5>
                <p class="ct_fs_15 ct_fw_500 text-center opacity-50 mb-0">
                  Sign in to manage and protect your assets with confidence.
                </p>
              </div>

              <div class="login-popup__roles">
                <div class="">
                  <label class="mt-3 ct_fs_16 ct_fw_400 mb-2">
                    Email / Phone
                  </label>
                  <input
                    type="text"
                    class="form-control ct_input ct_login_input"
                    placeholder="Enter email / phone"
                    id="identifier"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.identifier}
                  />
                  <ErrorMessage
                    errors={errors}
                    touched={touched}
                    fieldName="identifier"
                  />
                </div>
                <div class="">
                  <label class="mt-3 ct_fs_16 ct_fw_400 mb-2"> Password </label>
                  <div className="position-relative">
                    <input
                      class="form-control ct_input pe-5 ct_login_input"
                      placeholder="Enter password"
                      type={isEye ? "text" : "password"}
                      id="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values?.password}
                    />
                    <Eye isEye={isEye} onClick={setIsEye} />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    touched={touched}
                    fieldName="password"
                  />
                </div>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(webPaths?.ForgotPassword, {
                      state: buildAuthModalState(location),
                    });
                  }}
                  class="ct_fs_14 ct_fw_600 ct_green_text mt-3 text-end d-block text-end mt-2 ct_cursor_pointer"
                >
                  Forgot Password?
                </a>
              </div>

              <a
                onClick={(e) => {
                  e.preventDefault();
                  // navigate(webPaths?.Home);
                  handleSubmit();
                }}
                class="btn mt-4 ct_green_bnt ct_white_nowrap w-100"
              >
                Sign in
              </a>

              <p class="ct_fs_15 ct_fw_500 mt-3 mb-0 text-center">
                Don't have an account?
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(webPaths?.Signup, {
                      state: buildAuthModalState(location),
                    });
                  }}
                  class="ct_fs_15 ct_fw_600 ct_green_text ct_cursor_pointer"
                >
                  {" "}
                  Sign up
                </a>
              </p>
            </form>
          )}
        </Formik>
      </div>
    </AuthLayout>
  );
};

export default Login;
